import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: `'Sora', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
});
